$(document).ready(function() {
  $('.fancybox').fancybox({
    padding: 0,
    maxWidth: '100%',
    maxHeight: '100%',
    width: 560,
    height: 315,
    autoSize: true,
    closeClick: true,
    openEffect: 'elastic',
    closeEffect: 'elastic'
  });
});